import "blueimp-file-upload";
import "./style.scss";

class SingleFileUpload {
  constructor(
    app = null,
    uploaderSelector,
    targetSelector,
    preferences = {},
    options = {},
  ) {
    const PREFERENCES = {
      showLoader: true,
      thumbnail: true,
    };

    const OPTIONS = {
      dataType: "json",
      add: function (e, data) {
        data.submit();
      },
      done: function (e, data) {
        this.status = data;
      },
    };

    this.options = Object.assign({}, OPTIONS, options);
    this.preferences = Object.assign({}, PREFERENCES, preferences);

    this.label = document.querySelector("label[for=fileupload] span");
    this.target = document.querySelector(targetSelector);
    this.thumbnail = document.querySelector("#thumbnail");

    this.element = $(uploaderSelector);
    this.uploader = null;
    this.app = app;
  }

  addListeners() {
    this.uploader.on("fileuploadstart", (e, data) => {
      if (this.preferences.showLoader) {
        this.app.showLoader();
      }
    });

    this.uploader.on("fileuploadprogress", (e, data) => {
      console.log(Math.floor((data.loaded / data.total) * 100));
    });

    this.uploader.on("fileuploaddone", (e, data) => {
      const uploadedFile = data.result.data[0];

      if (this.preferences.thumbnail) {
        this.thumbnail.src = uploadedFile.thumbnail;
      }

      this.target.value = uploadedFile.name;
      this.label.innerText = uploadedFile.name;
      this.app.hideLoader();
      return data;
    });

    this.uploader.on("fileuploaderror", (e, data) => {
      this.reset();
      return data;
    });
  }

  reset() {
    this.target.value = null;
    this.label.innerText = "Dosya Seçin";
    if (this.preferences.thumbnail) {
      this.thumbnail.src = "/dist/assets/admin/images/no-image.png";
    }

    this.app.hideLoader();
  }

  init() {
    this.uploader = this.element.fileupload(this.options);
    this.addListeners();
  }
}

export default SingleFileUpload;
